import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useSelector } from "react-redux";
import _toArray from "lodash-es/toArray";
import renderHTML from "react-render-html";
import { toast } from "react-toastify";
import { ClosePopupHoc, DoneHoc, EditHoc, InfoHoc, MailiconSolidHoc, UnsavedContactHoc } from "../../../assets/images";
import { getActiveConversationChatId, getActiveConversationChatJid, getActiveConversationUserJid, getChatMessageHistoryById, getMessagesForReport, handleTempArchivedChats, isSingleChat } from "../../../Helpers/Chat/ChatHelper";
import { formatUserIdToJid, isLocalUser } from "../../../Helpers/Chat/User";
import { blockOfflineAction, getUserIdFromJid, isAppOnline } from "../../../Helpers/Utility";
import { updateMuteStatusActiveChat } from "../../../Redux/feature/activeChatDataSlice";
import { hideModal, showModal } from "../../../Redux/feature/popUpDataSlice";
import { updateMuteStatusRecentChat } from "../../../Redux/feature/recentChatDataSlice";
import { store } from "../../../Redux/store";
import SDK from "../../../SDK";
import ProfileImage from "../../Common/ProfileImage";
import Modal from "../Common/Modal";
import { ConformationPopup } from "../Popup/ComformationPopup";
import ContactInfoProfileUpdate from "../WebChatVCard/ContactInfoProfileUpdate";
import BlockUnBlockOption from "./BlockUnBlockOption";
import ClearDeleteOption from "./ClearDeleteOption";
import WebChatContactInfoMedia from "./WebChatContactInfoMedia";
import ActionInfoPopup from "../../ActionInfoPopup";
import { BLOCK_CONTACT_TYPE, CHAT_TYPE_SINGLE, REPORT_FROM_CONTACT_INFO, UNBLOCK_CONTACT_TYPE } from "../../../Helpers/Chat/Constant";
import BlockPopUp from "../ConversationSection/PopUp/BlockPopUp";
import { updateBlockedContactAction } from "../ConversationSection/PopUp/BlockAction";
import { isUserIBlocked } from "../../../Helpers/Chat/BlockContact";
import { REACT_APP_GROUP_NAME_CHAR } from "../../../processENV";
import { removeMoreNumberChar } from "../../../Helpers/Chat/ContentEditableEle";
import ContactInfoProfileView from "../WebChatVCard/ContactInfoProfileView";

const WebChatContactInfo = (props) => {
    const {
        participants = [],
        onInfoClose,
        chatType,
        activeChatDatas,
    } = props
    const [ groupName , setGroupName ] = React.useState(props.rosterName)
    // // const [ groupImage , setGroupImage ] = React.useState(props.rosterGroupImage)
    const [ groupNameCount, setgroupNameCount] = React.useState(0)
    const [ isBlocked , setIsBlocked ] = React.useState(false)
    const [ isBlockedMe , setIsBlockedMe ] = React.useState(false)
    const [ webChatInfo , setwebChatInfo] = React.useState({
        displayName: "",
        image: "",
        status: "",
        jid: "",
        showContactProfileImg: false,
        contactInfoMediaGrid: false,
        showModal: false,
        viewEdit: true,
        showDeletePopup: false,
        showReportPopup: false,
        reportPopup: '',
        showClearPopup: false,
        showMediaInDetailPopup: false,
        isLocalUserInGroup: true,
        errorMessage: false,
        exitGroup: false,
        confirmExitGroup: false,
        isAdmin:false,
        groupuniqueId:'',
        rosterProfile:"",
        isAdminBlocked:props?.roster?.isAdminBlocked,
        isDeletedAccount:props?.roster?.isDeletedUser
    })
    const {rosterProfile} = webChatInfo
    const storeData = useSelector((state) => state);
    const { activeChatData, vCardData, groupMembersData, rosterData, featureFlagList, blockedContact, contactsWhoBlockedMe } = storeData
    const { data:{fromUser = ""}} = vCardData 
    const { id: groupMemberListId , data: { groupJid } = {} }  = groupMembersData

    React.useEffect(()=>{
        setGroupName(props.rosterName)
        if (isChat()) {
            handleBlockUserData()
            return
        }
        updateLocalUserGroupState();
        handleGroupNameCount();
    },[])

    React.useEffect(()=>{
        if (isChat()) {
            handleBlockMeUser()
        }
    },[contactsWhoBlockedMe])
    
    React.useEffect(()=>{
        const rosterDetails = rosterData.data.find((item)=>{
            if(props.roster.userId === item.userId) return item
        })
        setwebChatInfo({
            ...webChatInfo,
            rosterProfile: rosterDetails
        })
    },[rosterData])

    React.useEffect(()=>{
        if(rosterData){
            const userId = props.roster?.userId
            const { data = [] } = rosterData
            let selectedUser = data.find(ele=> ele.userId === userId)
            setwebChatInfo({ ...webChatInfo,
                isAdminBlocked : selectedUser?.isAdminBlocked,
                isDeletedAccount:selectedUser?.isDeletedUser
            })
            if(selectedUser?.isDeletedUser || selectedUser?.isAdminBlocked){
                if(webChatInfo.showReportPopup){
                    toast.error( selectedUser?.isDeletedUser ? `Cannot report deleted user` :  `This user no longer available`)
                }
                setwebChatInfo({ ...webChatInfo,
                    showReportPopup: false,
                });
            }
        }
    },[rosterData?.id])

    React.useEffect(()=>{
        const preStateUserInGroup = webChatInfo.isLocalUserInGroup;
        const viewEditData = webChatInfo.viewEdit;
        if (preStateUserInGroup && !webChatInfo.isLocalUserInGroup) {
            // If local user is in the process of Add/Remove users, Make user as admin
            // At this time, if local user is removed from the group by other admin user,
            // we should block the local user from further process.
            const popupModelType = props?.popUpData?.modalProps?.modelType;
            const popupAction = props?.popUpData?.modalProps?.action;
            if (popupModelType === 'participants' || ["groupRemoveMember", "groupMakeAdmin"].indexOf(popupAction) > -1) {
                store.dispatch(hideModal())
                onInfoClose();
            }
            // Suppose If user try to edit the group name,
            // At this time, if local user is removed from the group by other admin user,
            // we should block the local user from further process.
            if (!viewEditData && webChatInfo.viewEdit) {
                onInfoClose();
            }
        }        
    },[webChatInfo.isLocalUserInGroup])
    
    React.useEffect(()=>{
        // setGroupImage(props.rosterGroupImage)
        setGroupName(props.rosterName)
    },[props.rosterName])

    React.useEffect(()=>{
          // Check group memebers list get update
          if (groupMemberListId.length !== 0) {
            updateLocalUserGroupState();
        }
    },[groupMembersData.id])

    React.useEffect(()=>{
        let checkUser = participants.find(ele => ele.userId === fromUser)
        if(!checkUser){
            setwebChatInfo({
                ...webChatInfo,
                isAdmin:false,
                groupuniqueId: groupJid
            })   
        }
        else if(checkUser?.userType === "o"){
            setwebChatInfo({
                ...webChatInfo,
                isAdmin:true,
                groupuniqueId: groupJid
            })   
        }
    },[groupMembersData.id,participants])

    /**
     * handleBlockUserData() method used to display contacts blocked/unblocked status.
     */
    const handleBlockUserData = () => {
        let blockedContactArr = blockedContact.data;
        const userJid = getActiveConversationChatJid();
        const isBlocked = blockedContactArr.indexOf(userJid) > -1;
        setIsBlocked( isBlocked )
    }

    const handleBlockMeUser = () => {
        let blockedContactArr = contactsWhoBlockedMe.data;
        const userJid = getActiveConversationChatJid();
        const isBlockedMe = blockedContactArr.indexOf(userJid) > -1;
        setIsBlockedMe( isBlockedMe )
    }

    const popUpToggleAction = () => {
        setwebChatInfo({
            ...webChatInfo,
            showModal: !webChatInfo.showModal
        })
    };

    const dispatchExitAction = () => {
        if (!isAppOnline()) {
            blockOfflineAction()
            return
        }
        const localUser = participants.find(users => isLocalUser(users.userId));
        const checkAdmin = localUser && localUser.userType === 'o' ? true : false;
        const userJid = localUser.userJid;
        store.dispatch(showModal({
            groupuniqueId: groupJid,
            userjid: userJid,
            checkAdmin,
            open: true,
            title: 'Are you sure you want to Exit from the group ?',
            activeclass: 'remove-participant',
            modelType: 'action',
            action: 'ExitGroup'
        }));

        setwebChatInfo({
            ...webChatInfo,
            exitGroup: false
        });
    };

    const handleChatMuteAction = async (muteStatus) => {
        if (blockOfflineAction()) return;

        const chatJids = getActiveConversationChatJid();
        SDK.updateMuteNotification(chatJids, muteStatus);
        const dispatchData = {
            fromUserId: getUserIdFromJid(chatJids),
            isMuted: muteStatus
        }
        store.dispatch(updateMuteStatusRecentChat(dispatchData));
        store.dispatch(updateMuteStatusActiveChat(dispatchData))
    };

    const updateLocalUserGroupState = () => {
        const localUser = participants.find(users => isLocalUser(users.userId));
        const isAdmin = localUser && localUser.userType === 'o';
        setwebChatInfo({
            ...webChatInfo,
            isAdmin: !!isAdmin,
            groupuniqueId: groupJid,
            isLocalUserInGroup: !!localUser,
            viewEdit: localUser ? webChatInfo.viewEdit : true,
            exitGroup: !localUser ? true : false,
        })
    }

    const handleEdit = event => {
        setwebChatInfo({
            ...webChatInfo, viewEdit: false });
    }

    const handleNewParticipants = () => {
        if (!webChatInfo.isAdmin) {
            return
        }
        const groupMembers = participants.map(participant => {
            const { userId, username, GroupUser } = participant
            return userId || username || GroupUser
        })
        store.dispatch(showModal({
            open: true,
            modelType: 'participants',
            groupName: props.rosterName,
            groupMembers: groupMembers,
            groupuniqueId: groupJid
        }))
    }

    const ClearPopupAction = () => {
        if (!checkMessageExist()) return;
        setwebChatInfo({
            ...webChatInfo,
            showClearPopup: !webChatInfo.showClearPopup
        })
    }

    const dispatchAction = async() => {
        const userJid = getActiveConversationChatJid();
        if (isBlocked) {
            const res = await SDK.unblockUser(userJid);
            if (res && res.statusCode === 200) {
                handleTempArchivedChats(userJid, CHAT_TYPE_SINGLE);
                setwebChatInfo({
                    ...webChatInfo,
                    // isBlocked: false,
                    showModal: false
                })
                setIsBlocked(false)
                updateBlockedContactAction(userJid, UNBLOCK_CONTACT_TYPE);
                toast.success(`${props.rosterName || 'User'} has been Unblocked`);
            }
        } else {
            const res = await SDK.blockUser(userJid);
            if (res && res.statusCode === 200) {
                handleTempArchivedChats(userJid, CHAT_TYPE_SINGLE);
                setwebChatInfo({
                    ...webChatInfo,
                    // isBlocked: true,
                    showModal: false
                })
                setIsBlocked(true)
                updateBlockedContactAction(userJid, BLOCK_CONTACT_TYPE);
                toast.success(`${props.rosterName || 'User'} has been Blocked`);
            }
        }
        
    }

    const checkMessageExist = () => {
        const chatMessages = getChatMessageHistoryById(getActiveConversationChatId());
        if (chatMessages && Array.isArray(chatMessages) && chatMessages.length === 0) {
            toast.info('There is no conversation.');
            return false;
        }
        return true;
    }

    /**
    * @param {string} message groupName
    * @param {number} lengthOfString how many char ahs been allowed
    */
    const findNegativeValue = (message = "", lengthOfString = 0) => {
        const groupNameLength = lengthOfString - _toArray(message).length;
        if (groupNameLength >= 0) {
            return lengthOfString - _toArray(message).length;
        }
        return 0;
    };

    const handleSaveGroupName = async (e) => {
        if (!isAppOnline()) {
            blockOfflineAction()
            return
        }
        let groupNames = groupName.trim();
        if (groupName.trim().length === 0) {
            setwebChatInfo({ ...webChatInfo,
                errorMessage: true
            })
            setGroupName(props.rosterName)
            return
        }
        if (props.rosterName !== groupName) {
            let groupImage = props.rosterImage;
            const groupJid = formatUserIdToJid(props.activeChatId, props.chatType)
            SDK.setGroupProfile(groupJid, groupNames, groupImage);
            // console.log("group response",frf, props)
        }
        setwebChatInfo({ ...webChatInfo, viewEdit: true, errorMessage: false })
        setGroupName(groupNames)
    }

    /**
     * handleWordCount() method to maintain state for characters left for username field.
     */
    const handleGroupName = event => {
        const { value = "" } = event.target;
        const message = removeMoreNumberChar(REACT_APP_GROUP_NAME_CHAR, value);
        setGroupName(message)
        setgroupNameCount(findNegativeValue(message, REACT_APP_GROUP_NAME_CHAR))
    }

    const handleGroupNameCount = () => {
        const group_name = groupName;
        const message = removeMoreNumberChar(REACT_APP_GROUP_NAME_CHAR, group_name);
        setgroupNameCount(findNegativeValue(message, REACT_APP_GROUP_NAME_CHAR))
    }

    /**
    * blockPopup render
    */
    const blockPopUpRender = () => {
       return (
           <BlockPopUp
               closeLabel={'Cancel'}
               dispatchAction={dispatchAction}
               popUpToggleAction={popUpToggleAction}
               actionLabel={`${isBlocked ? 'Unblock' : 'Block'}`}
               headerLabel={`${isBlocked ? 'Unblock' : 'Block'} ${groupName} ?`}
               infoLabel={`${isBlocked ? 'On unblocking, this contact will be able to call you or send messages to you.' : 'On blocking, this contact will not be able to call you or send messages to you.'}`}
           />
       )
   };

    const confirmMationUpRender = () => {//confirmationDialoge box
        return (
            <ConformationPopup
                dispatchAction={deleteOrClearAction}
                closeLabel={webChatInfo.showDeletePopup ? 'No' : 'Cancel'}
                actionLabel={`${webChatInfo.showDeletePopup ? 'Delete' : 'Clear'}`}
                headerLabel={confirmationPopUpDelete(webChatInfo.showDeletePopup)}
                label={`${webChatInfo.showDeletePopup ? 'DeleteAction' : 'ClearAction'}`}
                popUpToggleAction={webChatInfo.showDeletePopup ? deletePopupAction : ClearPopupAction}
            />
        )
    }

    const handleContactInfoImg = (e) => {
        if (props.rosterImage !== "") {
            setwebChatInfo({...webChatInfo, showContactProfileImg: !webChatInfo.showContactProfileImg })
            // // props.handlePopUpClassActive(!webChatInfo.showContactProfileImg);            
        }
    }
    
    const deleteOrClearAction = (data) => {
        const { isclear } = data;
        const isChatDelete = isChat();
        setwebChatInfo({
            ...webChatInfo,
            showModal: false,
            showDeletePopup: false,
            showClearPopup: false
        })
        if (isChatDelete) {
            const userJidDelete = getActiveConversationUserJid();
                isclear ? SDK.clearChat(userJidDelete) : SDK.deleteChat(userJidDelete);
                props.onInfoClose();
        } else {
                const groupJidDelete = getActiveConversationUserJid();
                isclear ? SDK.clearChat(groupJidDelete) : SDK.userDeleteGroup(groupJidDelete);
                props.onInfoClose();
            }
    }
    const confirmationPopUpDelete = (showDeletePopup = false) => {//labelDialoge
        if (showDeletePopup) {
            return `Are you sure you want to Delete the ${isChat() ? "chat" : "Group"} ?`
        }
        return `Are you sure you want to Clear the chat ?`
    };
    
    const deletePopupAction = () => {
        setwebChatInfo({
            ...webChatInfo,
            showDeletePopup: !webChatInfo.showDeletePopup
        })
    }
    
    const reportChatAction = (state = "", show = false) => {
        if(webChatInfo.isDeletedAccount || webChatInfo.isAdminBlocked){
            toast.error( webChatInfo.isDeletedAccount ? `Cannot report deleted user` :  `This user no longer available`)
            return
        }
        setwebChatInfo({ ...webChatInfo,
            showReportPopup: show,
            reportPopup: state
        });
    }

    const reportConfirmAction = async(event) => {
        if(event.detail <=1){
            if (blockOfflineAction()) return;
            if(webChatInfo.isDeletedAccount || webChatInfo.isAdminBlocked)return;
            const { activeChatId = "" } = props;
            const { chatId = "" } = activeChatDatas;
            const getChatJid = formatUserIdToJid(chatId,chatType)
            const getChatType = activeChatDatas.chatType
            const reportData = getMessagesForReport(activeChatId, REPORT_FROM_CONTACT_INFO)
            if(reportData.length === 0){
                toast.error(`No Messages To Report`)
                setwebChatInfo({ ...webChatInfo,
                    showReportPopup: false,
                });
            }else{
                await SDK.reportUserOrGroup(getChatJid,getChatType,reportData)
                toast.success(`Report sent`);
                setwebChatInfo({ ...webChatInfo,
                    showReportPopup: false,
                });
                }
        }
    }
    const isChat = () => isSingleChat(activeChatData?.data[0]?.recent?.chatType)
    const chatJid = getActiveConversationUserJid()
    let exitGroup = !participants.find(users => isLocalUser(users.userId));
    // // let userNameCursorPostion = 0;
    // // let userNameSelectedText = '';
    // // let userStatusCursorPostion = 0;
    // // let userStatusSelectedText = '';
    // // let addNewParticipantsPopOpen = false;
    return(
        <React.Fragment>
            <div>
                <div className="contactinfo-popup groupinfo-popup">
                    <div className="contactinfo">
                        <OutsideClickHandler onOutsideClick={(event) => {
                            if (event.target.classList.contains('popup')) return
                            if (webChatInfo.showClearPopup) {
                                ClearPopupAction();
                                return;
                            }
                            if (webChatInfo.showDeletePopup) {
                                deletePopupAction();
                                return;
                            }
                            if (webChatInfo.showModal) {
                                popUpToggleAction();
                                return;
                            }
                            if (webChatInfo.showReportPopup) {
                                return '';
                            }
                            onInfoClose()
                        }}>
                            {(webChatInfo.showDeletePopup || webChatInfo.showClearPopup || webChatInfo.showModal) &&
                                <Modal containerId='container'>
                                    {webChatInfo.showDeletePopup || webChatInfo.showClearPopup ?
                                        confirmMationUpRender() : blockPopUpRender()
                                    }
                                </Modal>}
                            <div className="contactinfo-header">
                                <i onClick={props.onInfoClose} >
                                    <ClosePopupHoc viewBox="0 0 24 24"/>
                                </i>
                                <h4>{isChat() ? "Contact info" : "Group info"}</h4>
                            </div>
            
                            {isChat() && <div className="single-details-container">
                                <div className="contactinfo-image-block">
                                    <ProfileImage
                                        chatType={'chat'}
                                        temporary={false}
                                        emailContactInfo={true}
                                        imageToken={props.isAdminBlocked ? "" : props.rosterImage}
                                        // blocked={isUserWhoBlockedMe(chatJid)}
                                        profileImageView={handleContactInfoImg}
                                        emailId={props.roster?.emailId}
                                        userId={chatJid}
                                    />
                                    <span
                                        title={props.getName}>
                                        {props.getName}
                                    </span>
                                </div>
                                {webChatInfo.showContactProfileImg && !isBlockedMe && (                                   
                                    <ContactInfoProfileView
                                        chatType={'chat'}
                                        blocked={isUserIBlocked(chatJid)}
                                        temporary={false}
                                        imageToken={props.rosterImage}
                                        chatJid={chatJid}
                                        handleContactInfoImg={handleContactInfoImg}
                                    /> 
                                )}
                                {(props.roster.emailId || props.mobileNumber || props.userstatus) &&
                                <div className="contactinfo-about-no">
                                    {/* <h5>{props.roster.emailId ? ABOUT_AND_EMAIL_ID : ABOUT_AND_PHONE_NO}</h5> */}
                                    <h5>{"Email and phone number"}</h5>
                                    {(props.roster.email || rosterProfile.email) &&
                                        <div className="about-no">
                                            <i className="statusIcon">
                                                <MailiconSolidHoc viewBox="0 0 17 12.114"/>
                                            </i>
                                            {/* <UserStatus
                                                userId={chatJid}
                                                status={props.userstatus}
                                            /> */}
                                            {rosterProfile.email === undefined ? 
                                                <span>{props.roster.email}</span> : <span>{rosterProfile.email}</span> 
                                            }
                                        </div>
                                    }
                                    { (props.roster.mobileNumber || rosterProfile.mobileNumber) &&
                                    <div className="about-no">
                                        <i >
                                            {props.roster.emailId ? <MailiconSolidHoc viewBox="0 0 17 12.114" /> : <UnsavedContactHoc viewBox="0 0 18.199 18.2"/>}
                                        </i>
                                        {rosterProfile.mobileNumber === undefined ? 
                                            <span>{props.roster.mobileNumber}</span> : <span>{rosterProfile.mobileNumber}</span> 
                                        }
                                    </div>
                                    }
                                </div>
                                }

                                <WebChatContactInfoMedia
                                    jid={chatJid}
                                    chatType={chatType}
                                />
                                <BlockUnBlockOption
                                    handleChatMuteAction={handleChatMuteAction}
                                    isBlocked={isBlocked}
                                    ClearPopupAction={ClearPopupAction}
                                    popUpToggleAction={popUpToggleAction}
                                    deletePopupAction={deletePopupAction}
                                    reportSingleChatAction={() => reportChatAction('single', true)}
                                    // isAdminBlocked={isAdminBlocked}
                                    featureStateData={featureFlagList?.data}
                                />
                            </div>
                            }
                            {!isChat() &&
                                <div className="group-details-container">
                                    <div className="contactinfo-image-block">
                                        <ContactInfoProfileUpdate
                                            chatType={'groupchat'}
                                            blocked={false}
                                            temporary={false}
                                            imageToken={props.rosterImage}
                                            jid={chatJid}
                                            groupName={props.rosterName}
                                            participants={participants}
                                        />
                                        <div className="groupinfo-details">
                                            {!webChatInfo.viewEdit && <>
                                                <input
                                                    type="text"
                                                    value={groupName}
                                                    id="username"
                                                    name="userName"
                                                    maxLength={findNegativeValue(groupName, REACT_APP_GROUP_NAME_CHAR) > 0 ? 1000 : 0}
                                                    onChange={handleGroupName}
                                                    autoFocus
                                                    // onMouseUp={(e) => {
                                                    //     userNameCursorPostion = e.target.selectionStart;
                                                    // }}
                                                    // onKeyUp={(e) => {
                                                    //     userNameCursorPostion = e.target.selectionStart;
                                                    // }}
                                                    // onBlur={(e) => {
                                                    //     userNameSelectedText = getSelectedText();
                                                    // }}
                                                ></input>
                                                <span className="group-count">
                                                    {groupNameCount}
                                                </span>
                                                </>
                                            }
                                            {/** {!viewEdit &&
                                                <i className="emoji">
                                                    <WebChatEmoji
                                                        onEmojiClick={this.onEmojiClickUsername}
                                                    />
                                                </i>
                                            }    */}
                                            {webChatInfo.viewEdit &&
                                                <h4 title={groupName}>
                                                    {renderHTML(groupName)}
                                                </h4>
                                            }
                                        </div>
                                        <div className="groupinfo-controls">
                                            {webChatInfo.isLocalUserInGroup && !exitGroup && (!webChatInfo.viewEdit ? <i className="editgroupdone" onClick={handleSaveGroupName}><DoneHoc viewBox="0 0 14 10"/></i> :
                                                <i className="editgroupedit"
                                                    onClick={handleEdit}>
                                                    <EditHoc viewBox="0 0 18 18"/>
                                                </i>)
                                            }
                                        </div>
                                            {webChatInfo.errorMessage && <div className="errorMessageContact"><InfoHoc viewBox="0 0 8.683 8.683"/><span className="group_name">Group name cannot be empty</span></div>}
                                    </div>
                                    <WebChatContactInfoMedia
                                        chatType={chatType}
                                    />
                                    <ClearDeleteOption
                                        handleChatMuteAction={handleChatMuteAction}
                                        isAdmin={webChatInfo.isAdmin}
                                        exitGroup={webChatInfo.exitGroup}
                                        groupuniqueId={webChatInfo.groupuniqueId}
                                        vCardData={vCardData}
                                        participants={participants}
                                        ClearPopupAction={ClearPopupAction}
                                        deletePopupAction={deletePopupAction}
                                        dispatchExitAction={dispatchExitAction}
                                        handleNewParticipants={handleNewParticipants}
                                        reportGroupChatAction={() => reportChatAction('group', true)}
                                        // contactPermission={this.props.contactPermission}
                                    />
                                    {/* 
                                        this.state.contactPermissionPopup && <ActionInfoPopup
                                        textActionBtn={"Ok"}
                                        textHeading={"Contact permission"}
                                        textInfo={ADD_PARTICIPANT_GROUP_CONTACT_PERMISSION_DENIED}
                                        />
                                    */}
                                </div>
                            } 
                            {/* showMediaInDetailPopup &&
                                <ShowMediaInDetailPopup /> */}
                        </OutsideClickHandler>
                    </div>
                    <div className="outsideHandler" ></div>
                </div>
                {/* contactInfoMediaGrid &&
                    <ContactInfoMediaGrid
                        handleContactMedia={this.handleContactMedia}
                    />
                 */}
            </div>
            {webChatInfo.showReportPopup &&
                <ActionInfoPopup
                    textActionBtn={"Report"}
                    btnActionClass={"red"}
                    textCancelBtn={"Cancel"}
                    textHeading={`Report ${props.rosterName}?`}
                    handleAction={(e) => reportConfirmAction(e)}
                    handleCancel={() => setwebChatInfo({ ...webChatInfo, showReportPopup: false })}
                    textInfo={
                        `The last 5 messages from this ${webChatInfo.reportPopup === 'single' ?
                        "contact" : "group"
                        } will be forwarded to admin. 
                        ${webChatInfo.reportPopup === 'single' ?
                            "This contact will not be notified." : ""
                        }
                        ${webChatInfo.reportPopup === 'group' ?
                            "No one in this group will be notified." : ""}
                        `}
                >
                    {/* 
                       this.state.reportPopup === 'group' &&
                            <React.Fragment>
                                <div className='check_option'>
                                    <div className="checkbox-common">
                                        <input
                                            name="participants"
                                            type="checkbox"
                                            checked={confirmExitGroup}
                                            onChange={() => this.setState({
                                                confirmExitGroup: !confirmExitGroup
                                            })}
                                            value={"confirmExitGroup"}
                                            id={"confirmExitGroup"}
                                        />
                                        <label htmlFor={"confirmExitGroup"}></label>
                                    </div>
                                    <label htmlFor={"confirmExitGroup"}>Exit group</label>
                                </div>
                            </React.Fragment>
                    */}
                </ActionInfoPopup>
                }
        </React.Fragment>
    )
}
export default WebChatContactInfo;